import { browser } from "$app/env";
import { consoleClient } from "../api.ts";
import { loadShowcase } from "../entrance/showcase.ts";
import type { ShowcaseServer } from "../entrance/showcase.ts";
import type { Fetch } from "@colossus/api-client";

export interface ProductData {
  readonly showcase: Promise<readonly ShowcaseServer[]>;
}

export const loadProduct = ({ fetch }: { fetch: Fetch }): ProductData => ({
  showcase: browser ? loadShowcase(consoleClient(fetch)) : Promise.resolve([]),
});
